<template>
  <div class="tongji-category-page">
    <div class="hero-card">
      <div>
        <div class="hero-title">分类素材管理</div>
        <div class="hero-desc">固定展示话语、自然、背景、动物、其他 5 个分类。点卡片进入详情，点图片可直接修改图片地址。</div>
      </div>
      <div class="hero-actions">
        <el-button type="primary" icon="el-icon-refresh" @click="loadData">刷新</el-button>
      </div>
    </div>

    <div class="stats-row">
      <div class="stats-card">
        <div class="stats-label">分类总数</div>
        <div class="stats-value">{{ categoryList.length }}</div>
      </div>
      <div class="stats-card">
        <div class="stats-label">数据总条数</div>
        <div class="stats-value">{{ totalItems }}</div>
      </div>
    </div>

    <div class="category-grid" v-loading="loading">
      <div
        v-for="item in categoryList"
        :key="item.id"
        class="category-card"
        @click="goDetail(item)"
      >
        <div class="image-wrap" @click.stop="openImgDialog(item)">
          <img v-if="item.img" :src="item.img" class="card-image" />
          <div v-else class="card-image empty-image">{{ getFirstChar(item.name) }}</div>
          <div class="image-mask">点击修改图片</div>
        </div>
        <div class="card-body">
          <div class="card-title-row">
            <div class="card-title">{{ item.name }}</div>
            <div class="card-id">ID {{ item.id }}</div>
          </div>
          <div class="card-count">当前数据 {{ item.item_total || 0 }} 条</div>
          <div class="card-actions">
            <el-button type="text" @click.stop="goDetail(item)">进入详情</el-button>
            <el-button type="text" @click.stop="openImgDialog(item)">修改图片</el-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!loading && !categoryList.length" class="empty-box">
      暂无分类数据
    </div>

    <el-dialog
      title="修改分类图片"
      :visible.sync="imgDialogVisible"
      width="620px"
    >
      <div class="dialog-name">{{ currentCategory.name || '未命名分类' }}</div>
      <el-form label-width="90px">
        <el-form-item label="图片地址">
          <el-input
            v-model="imgForm.img"
            type="textarea"
            :rows="4"
            placeholder="请输入图片地址"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="imgDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitImgEdit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      apiBase: 'https://tossp.yoooooo.com/index.php/index/tongji',
      loading: false,
      submitLoading: false,
      categoryList: [],
      imgDialogVisible: false,
      currentCategory: {},
      imgForm: {
        id: 0,
        img: ''
      }
    }
  },
  computed: {
    totalItems() {
      return (this.categoryList || []).reduce(function(total, item) {
        return total + Number(item.item_total || 0)
      }, 0)
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await axios.post(this.apiBase + '/getTongjiCategoryList')
        if (res.data.code === 200) {
          this.categoryList = res.data.data || []
        } else {
          this.$message.error(res.data.msg || '加载失败')
        }
      } catch (e) {
        this.$message.error('加载失败')
      }
      this.loading = false
    },
    openImgDialog(item) {
      this.currentCategory = item || {}
      this.imgForm = {
        id: item.id,
        img: item.img || ''
      }
      this.imgDialogVisible = true
    },
    async submitImgEdit() {
      this.submitLoading = true
      try {
        const res = await axios.post(this.apiBase + '/updateTongjiCategoryImg', this.imgForm)
        if (res.data.code === 200) {
          this.$message.success('修改成功')
          this.imgDialogVisible = false
          this.loadData()
        } else {
          this.$message.error(res.data.msg || '保存失败')
        }
      } catch (e) {
        this.$message.error('保存失败')
      }
      this.submitLoading = false
    },
    goDetail(item) {
      this.$router.push({
        name: 'TongjiCategoryDetail',
        query: {
          category_id: item.id
        }
      })
    },
    getFirstChar(name) {
      if (!name) {
        return '图'
      }
      return String(name).slice(0, 1)
    }
  }
}
</script>

<style scoped>
.tongji-category-page {
  min-height: 100vh;
  padding: 24px;
  background: #f4f7fb;
  box-sizing: border-box;
}

.tongji-category-page,
.tongji-category-page * {
  box-sizing: border-box;
}

.hero-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  margin-bottom: 20px;
  border-radius: 20px;
  background: linear-gradient(135deg, #3758ff 0%, #7f63ff 100%);
  color: #fff;
  box-shadow: 0 16px 36px rgba(73, 90, 255, 0.2);
}

.hero-title {
  font-size: 24px;
  font-weight: 700;
}

.hero-desc {
  margin-top: 8px;
  font-size: 14px;
  opacity: 0.92;
}

.stats-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px 20px;
}

.stats-card {
  width: calc(25% - 16px);
  min-width: 220px;
  margin: 0 8px 16px;
  padding: 20px 22px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(31, 45, 61, 0.06);
}

.stats-label {
  color: #8a94a6;
  font-size: 14px;
}

.stats-value {
  margin-top: 10px;
  color: #1f2d3d;
  font-size: 28px;
  font-weight: 700;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.category-card {
  overflow: hidden;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(31, 45, 61, 0.08);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.category-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 38px rgba(31, 45, 61, 0.12);
}

.image-wrap {
  position: relative;
  height: 200px;
  overflow: hidden;
  background: #edf2ff;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.empty-image {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4862ff;
  font-size: 56px;
  font-weight: 700;
}

.image-mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 14px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.58) 100%);
  color: #fff;
  font-size: 13px;
}

.card-body {
  padding: 18px 18px 16px;
}

.card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.card-title {
  color: #1f2d3d;
  font-size: 18px;
  font-weight: 700;
}

.card-id {
  flex-shrink: 0;
  height: 24px;
  line-height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: #edf4ff;
  color: #245bdb;
  font-size: 12px;
  font-weight: 700;
}

.card-count {
  margin-top: 12px;
  color: #7d8ba3;
  font-size: 14px;
}

.card-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
}

.empty-box {
  padding: 60px 20px;
  text-align: center;
  color: #8a94a6;
  font-size: 14px;
}

.dialog-name {
  margin-bottom: 18px;
  color: #1f2d3d;
  font-size: 16px;
  font-weight: 600;
}

@media screen and (max-width: 768px) {
  .tongji-category-page {
    padding: 16px;
  }

  .hero-card {
    display: block;
  }

  .hero-actions {
    margin-top: 16px;
  }

  .stats-card {
    width: calc(100% - 16px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/aatongjiCategory.vue